"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const react_1 = require("react");
const components_1 = require("components");
const Alphaeon_Patient_Financing_Logo_png_1 = __importDefault(require("images/Alphaeon_Patient_Financing_Logo.png"));
const inline_colors_1 = require("inline-colors");
const AppModalHeader = ({ handleClose }) => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "app-modal-header flex space-between", children: [(0, jsx_runtime_1.jsx)("img", { src: Alphaeon_Patient_Financing_Logo_png_1.default, alt: "Alphaeon Credit" }), (0, jsx_runtime_1.jsx)("div", { className: "close-button-container", children: (0, jsx_runtime_1.jsx)(components_1.Button, { type: "button", onClick: handleClose, children: (0, jsx_runtime_1.jsx)(Close_1.default, { className: "close-button", htmlColor: inline_colors_1.INLINE_COLORS.blackBase, "data-testid": "modal-close-button" }) }) })] }));
};
const FullPageModal = ({ btnText = 'RETURN TO DASHBOARD', children, isOpen, setIsOpen, }) => {
    // State
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(isOpen);
    const handleBtnClose = () => {
        setIsModalOpen(false);
    };
    const handleClose = (_event, reason) => {
        if (reason && reason === 'backdropClick')
            setIsModalOpen(false);
    };
    (0, react_1.useEffect)(() => {
        if (isOpen === true) {
            setIsModalOpen(true);
        }
    }, [isOpen]);
    (0, react_1.useEffect)(() => {
        if (isModalOpen === false) {
            setIsOpen(false);
        }
    }, [isModalOpen]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(core_1.Modal, { keepMounted: false, open: !!isModalOpen, onClose: handleClose, "aria-labelledby": "modal-modal-title", "aria-describedby": "modal-modal-description", children: (0, jsx_runtime_1.jsxs)("div", { className: "vh100 bg-white overflow-scroll", children: [(0, jsx_runtime_1.jsx)(AppModalHeader, { handleClose: handleBtnClose }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-center flex-dir-col", children: [children, btnText && ((0, jsx_runtime_1.jsxs)(components_1.Button, { type: "button", onClick: handleBtnClose, className: "button-primary button-warn-outline", "data-testid": "add-signer-return-to-dashboard-button", children: ["\u00A0\u00A0\u00A0", btnText, "\u00A0\u00A0\u00A0"] }))] })] }) }) }));
};
exports.default = FullPageModal;
